import Setting from "./index";
import Currency from "./Currency";
import TradePair from "./TradePair";
import "./CTF/store";
import Robot from "./Robot";
import Banner from "./Banner";
import Content from "./Content";
import WalletSwitch from "./WalletSwitch";
import ProcessorConfig from "./ProcessorConfig";
import CurrencyIntroduction from "./CurrencyIntroduction";
import SpotCoinAdmin from "./SpotCoinAdmin";
import walletSwitchCold from "./WalletSwitchCold";
import Poster from "./Poster";
import Push from "./push";
import community from "./Community";
import chatRoom from "./Chatroom";
import CountryCode from "./CountryCode";
import KlineRepair from "./KlineRepair";
import SpotKlineRepair from "./SpotKlineRepair";
import AppLineUrl from "./AppLineUrl";
// import Order from './Order'
// import Appconfigure from './AppStartPage'
import AppStartPage from "./AppStartPage"; //启动页
import AppAdvertisePage from "./AppAdvertisePage"; //广告页
import AppFunctionalPage from "./AppFunctionalPage"; //金刚区
import ConfigI18n from "./Config-i18n";
import CurrencyTransfer from "./CurrencyTransfer";
import Channel from "./Channel";
import ChannelCodeInfo from "./Channel/components/info";
import PriceControl from "./PriceControl";
import NodeConfig from './NodeConfig'
import Telegram from "./Telegram";
import FunctionUrlConfig from "./FunctionUrlConfig";

export default {
  path: "/home/setting",
  component: Setting,
  children: [
    { path: "/home/setting/countryCode", component: CountryCode },
    { path: "/home/setting/Config-i18n", component: ConfigI18n },
    { path: "/home/setting/currency", component: Currency },
    { path: "/home/setting/currencyTransfer", component: CurrencyTransfer },
    // { path: '/home/setting/order', component: Order },
    { path: "/home/setting/tradePair", component: TradePair },
    { path: "/home/setting/robot", component: Robot },
    { path: "/home/setting/banner", component: Banner },
    { path: "/home/setting/chatroom", component: chatRoom },
    { path: "/home/setting/poster", component: Poster },
    { path: "/home/setting/content", component: Content },
    { path: "/home/setting/walletSwitch", component: WalletSwitch },
    { path: "/home/setting/processorConfig", component: ProcessorConfig },
    { path: "/home/setting/appLineUrl", component: AppLineUrl },
    { path: "/home/setting/telegram", component: Telegram },
    { path: "/home/setting/functionUrlConfig", component: FunctionUrlConfig },
    { path: "/home/setting/priceControl", component: PriceControl },
    { path: "/home/setting/channel", component: Channel },
    {
      path: "/home/setting/channel/channelCodeInfo/:id",
      component: ChannelCodeInfo,
    },
    { path: "/home/setting/AppStartPage", component: AppStartPage },
    { path: "/home/setting/nodeConfig", component: NodeConfig },
    { path: "/home/setting/AppAdvertisePage", component: AppAdvertisePage },
    { path: "/home/setting/AppFunctionalPage", component: AppFunctionalPage },
    {
      path: "/home/setting/currencyIntroduction",
      component: CurrencyIntroduction,
    },
    {
      path: "/home/setting/spotCoinAdmin",
      component: SpotCoinAdmin,
    },
    { path: "/home/setting/walletSwitchCold", component: walletSwitchCold },
    { path: "/home/setting/push", component: Push },
    { path: "/home/setting/klineRepair", component: KlineRepair },
    { path: "/home/setting/spotKlineRepair", component: SpotKlineRepair },
    { path: "/home/setting/community", component: community },
  ],
};
